import CustomCheckbox from "components/Atoms/CustomCheckbox"
import { useRowSelector } from "components/Molecules/RowSelector"
import useAuth from "hooks/useAuth"
import React from "react"

/**
 * This simple component is extracted to its own module because it may involve business logic
 * in the future, feel free to consider refactoring if you feel otherwise
 */
const DemandSelector = ({ demandId, isVerified = false }) => {
  const [isChecked, setChecked] = useRowSelector({
    path: "demands",
    payload: { id: demandId },
  })

  const me = useAuth()
  const demandWhatsappApproval =
    me?.user?.currentDepartment?.demandWhatsappApproval

  return (
    <CustomCheckbox
      rounded
      large
      disabled={demandWhatsappApproval && !isVerified}
      className="mb-0"
      intent="success"
      checked={isChecked ? true : false}
      onClick={e => {
        e.stopPropagation()
        setChecked()
      }}
    />
  )
}

export default DemandSelector
